import { render, staticRenderFns } from "./NutrientRemovalEditor.vue?vue&type=template&id=00a4da70&scoped=true&lang=html&"
import script from "./NutrientRemovalEditor.vue?vue&type=script&lang=js&"
export * from "./NutrientRemovalEditor.vue?vue&type=script&lang=js&"
import style0 from "./NutrientRemovalEditor.vue?vue&type=style&index=0&id=00a4da70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4da70",
  null
  
)

export default component.exports